<template lang="pug">
    section.ai-simple.section
        ._wrap.wrap
            ._inner(:class="`ai-simple__inner_${ai}`")
                h2._title(v-html="title")
                ._description(v-html="description")
                picture
                  source(:srcset="image.replace('.png', '.webp')" type="image/webp")
                  img(:src="image" loading="lazy" sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 40vw")._preview
                ui-button(variant="rounded" :text="btn" :loading="isLoading" @click="handleLoginClick")._btn
</template>

<script>
import UiButton from "@/components/ui/ui-button/ui-button.vue";

export default {
    name: "AiSimple",
    components: { UiButton },
    props: {
        ai: {
            type: String,
            default: "chatGPT",
            required: false
        }
    },
    data() {
        return {
            isLoading: false,
        };
    },
    computed: {
        title: state => state.$t(`AILanding.simple.titles.${state.ai}`),
        description: state => state.$t(`AILanding.simple.descriptions.${state.ai}`),
        btn: state => state.$t(`AILanding.simple.btns.${state.ai}`),
        image: state => require(`../../../assets/images/ai-simple/${state.ai}.png`)
    },
    methods: {
        handleLoginClick() {
            this.isLoading = true;
            this.$router.push("/welcome/login");
        },
    },
};
</script>

<style lang="scss" src="./ai-simple.scss"></style>
